import { teamFunctions, leadershipImgs, s3Bucket } from ".";

export const boardArr = () => [
    {
        name: "Sassan Saatchi",
        img: leadershipImgs.sassan,
        func: teamFunctions.leadership,
        title: "CEO, Co-Founder, Chief Scientist",
    },
    {
        name: "Dee Lawrence",
        title: "Director and co-founder, High Tide Foundation",
        local: "USA",
        img: `${s3Bucket}dlawrence.jpg`,
    },
    {
        name: "Caroline de Bossart",
        title: "Director, Neglected Climate Opportunities, Grantham Foundation for the Protection of the Environment",
        local: "USA",
        img: `${s3Bucket}cdebossart.jpg`,
    },
    {
        name: "William Boyd",
        title: "Professor of Law, UCLA School of Law; Professor, UCLA Institute of the Environment and Sustainability; Project Lead, Governors' Climate and Forests Task Force",
        local: "USA",
        img: `${s3Bucket}wboyd.jpg`,
    },
    {
        name: "Lee White",
        title: "Special Envoy, Science Panel for the Congo Basin",
        local: "USA",
        img: `${s3Bucket}lwhite.jpg`,
    },
];
